/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleBrandQueryData
 */
export interface GoogleSearchConsoleBrandQueryData {
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandQueryData
     */
    query?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandQueryData
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandQueryData
     */
    matchedTerm?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleSearchConsoleBrandQueryData
     */
    ruleVersion?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandQueryData
     */
    clicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandQueryData
     */
    impressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandQueryData
     */
    ctr?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandQueryData
     */
    position?: string | null;
}

/**
 * Check if a given object implements the GoogleSearchConsoleBrandQueryData interface.
 */
export function instanceOfGoogleSearchConsoleBrandQueryData(value: object): value is GoogleSearchConsoleBrandQueryData {
    return true;
}

export function GoogleSearchConsoleBrandQueryDataFromJSON(json: any): GoogleSearchConsoleBrandQueryData {
    return GoogleSearchConsoleBrandQueryDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandQueryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleBrandQueryData {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'] == null ? undefined : json['query'],
        'category': json['category'] == null ? undefined : json['category'],
        'matchedTerm': json['matchedTerm'] === undefined ? undefined : json['matchedTerm'] === null ? null : json['matchedTerm'],
        'ruleVersion': json['ruleVersion'] === undefined ? undefined : json['ruleVersion'] === null ? null : json['ruleVersion'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'ctr': json['ctr'] == null ? undefined : json['ctr'],
        'position': json['position'] === undefined ? undefined : json['position'] === null ? null : json['position'],
    };
}

export function GoogleSearchConsoleBrandQueryDataToJSON(json: any): GoogleSearchConsoleBrandQueryData {
    return GoogleSearchConsoleBrandQueryDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandQueryDataToJSONTyped(value?: GoogleSearchConsoleBrandQueryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'query': value['query'],
        'category': value['category'],
        'matchedTerm': value['matchedTerm'],
        'ruleVersion': value['ruleVersion'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'ctr': value['ctr'],
        'position': value['position'],
    };
}

